export class HomepageQuestionModel {
  id: number;
  question: string;
  answer: string;
  showAnswer: boolean;

  constructor(id: number, question: string, answer: string, showAnswer: boolean) {
    this.id = id;
    this.question = question;
    this.answer = answer;
    this.showAnswer = showAnswer;
  }
}
